export default __webpack_public_path__ + "static/media/md-card-bg-GCP.fedb9042.png";